module.exports = __webpack_public_path__ + "static/media/4 Wheeler.7e41d0a6.svg";